export default {"src":"/_next/static/media/WhatsApp.8845eb54.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};